import { SECTION, THEME, WIDGET } from '../../models/app-json';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, ElementRef, TemplateRef,ViewChild, EventEmitter, Output, Renderer2, OnDestroy } from '@angular/core';
import { SharedService } from '../Services/shared.service';
import { Subscription, take,switchMap,catchError,of, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FORMI, PAGEI } from '../../models/page_config_json';
import { APIConfigMapping, APP_BUILDER_PERMISSIONS, AppPermissionsPipe, HTTPAPIConfig, PERMISSIONS_ACTIONS, VlDataService, VlHttpService, isNullOrUndefined } from 'shared-library';
import { interval } from 'rxjs';
import { WIDGET_TYPES, LAST_SELECTED_OPTION, pageTypeCnsts, Default_Pages, PAGE_FORM_TYPES, PAGETYPES } from '../../constants/proj.cnst';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare const WebFont: any;

@Component({
  selector: 'lib-mobile-screen',
  templateUrl: './mobile-screen.component.html',
  styleUrls: ['./mobile-screen.component.scss'],
  providers: [AppPermissionsPipe]
})
export class MobileScreenComponent implements OnDestroy{
  @ViewChild('addPagePopUp') addPagePopUpTemplate!: TemplateRef<any>;
    applicationId!:string;
  applicationData!:any;
  applicationTheme!:THEME;
  pageSectionList1!: FORMI[];
  pageIndex!:number;
  subscriptions: Subscription[] = [];
  isEditableSection: boolean = false;
  displayRestrictedArea!: boolean;
  widgetDropTriggered = false;
  currentlyHoveredWidget: { sectionIndex: number; widgetIndex: number } | null = null;
  pageData!: PAGEI;
  widgetTypes = WIDGET_TYPES;
  isShowMenu:boolean = false;
  currentTime: string = '';
  selectedHeadFontFamily: string = 'Roboto';
  selectedBodyFamily :string = 'Roboto';
  private intervalSubscription: any;
  queryParamsData:any;
  addPageForm!:FormGroup;
  editPage:boolean=false;
  pageAlreadyExits:boolean = false;
  dropData:any;
  userInfo: any;
  spinnerActive:boolean = false;
  defaultPages:any[] = [pageTypeCnsts.SPLASH_SCREEN, pageTypeCnsts.LOGIN]
  formTypes:any = PAGE_FORM_TYPES
  @ViewChild('dropZone',{read:ElementRef,static:true}) dropZone!:ElementRef;
  destroy$:Subject<void> = new Subject();
  // nav bar
  navBarConfig:any = {};
  navBarIndex!:number;
  // manu panel
  menuBarConfig:any = {};
  menuPanelIndex!:number;
  // main form (widgets form)
  widgetsForm:any = {};
  widgetsFormIndex!:number;

  appPermissions = APP_BUILDER_PERMISSIONS;
  permissionsActions = PERMISSIONS_ACTIONS;
  pageTypes = PAGETYPES;
  _currentIndex : any;
  _currentField : any;
  _pointerPosition : any;
  pageId: any;
  @Output() onDrop1= new EventEmitter<any>();
  trackByFn(index: number, item: string): any {
    return item;
  }
  drop(event: any) {
    this.onDrop1.emit(event);
  }

  
  constructor(private sharedSrv: SharedService,
    private route: ActivatedRoute,
    private router: Router,
    public dialogref: MatDialog,
    private dataService: VlDataService,
    private httpService: VlHttpService,
    private toastrSer : ToastrService,
    public dialog: MatDialog,
    private renderer: Renderer2,
    private el: ElementRef,
    private _formBuilder:FormBuilder,
    private appPermissionPipe: AppPermissionsPipe,
    ) {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo') as string);
    }

  getPageById(pageId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGE']);
    apiConfig.postData = {page_id: pageId}
   return this.httpService.placeAPICall(apiConfig);
  }

  ngOnInit() {
    this.buildForms();
    this.sharedSrv.themesObj.pipe(takeUntil(this.destroy$)).subscribe((theme:THEME) => {
      this.updateStyles(theme.primaryColor,theme.secondaryColor,theme.defaultBackgroundColor,theme.themeName ?? '');
      this.applicationTheme = theme;
      this.applyPageTheme(this.pageData);
      this.selectedHeadFontFamily = isNullOrUndefined(theme?.headingFont) ? "Roboto" : theme?.headingFont ?? '';
      this.selectedBodyFamily = isNullOrUndefined(theme?.bodyFont) ? "Roboto" : theme?.bodyFont ?? ''
      this.loadFont();
    }) 

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.pageId = params['pageId'];
      this.queryParamsData = params;
      this.applicationId = params['id'];
      this.sharedSrv.setSidenavContentlistOption('',false);

      if(this.pageId !== undefined){
        this.navBarConfig = undefined;
        this.menuBarConfig = undefined;
        this.widgetsForm = undefined;
        this.navBarIndex = -1;
        this.menuBarConfig = -1;
        this.widgetsForm = -1;
        this.getPageById(this.pageId).pipe(take(1),takeUntil(this.destroy$)).subscribe((data) => {
          if(data.forms){
            let pages = this.sharedSrv.getPages();
            this.pageIndex = pages.findIndex((page:any) => page.pageId === this.pageData.pageId);
            this.sharedSrv.setSelectedPage(data);
          }else{
            this.toastrSer.error("slow NetWork, Try again.")
          }
        });
        
      }else {
        if(this.applicationData){
        this.pageData = {applicationId:this.applicationId,pageName:''}
        this.pageSectionList1 = [];
        }
      }
    })

    this.sharedSrv.selectedPageObj$.pipe(takeUntil(this.destroy$)).subscribe((page) => {
      if(this.pageId){
      this.applyPageTheme(page);
      this.pageSectionList1 = page.forms;
      if(page.forms?.length > 0){
        this.setPageForms(page.forms);
      }
      this.pageData = page;
      }else{
        this.pageData = {applicationId:this.applicationId,pageName:''}
        this.pageSectionList1 = [];
      }
    })

    this.sharedSrv.showMenuStatus$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.isShowMenu = value;
    })
    
    this.updateTime();

    this.intervalSubscription = interval(1000).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateTime();
    });
  }

  setPageForms(pageForms:any){
    pageForms.forEach((form:any,index:number) => {
      switch (form.formConfig.formType) {
        case this.formTypes.navbar:
          this.navBarConfig = form;
          this.navBarIndex = index;
          break;
        case this.formTypes.menuPanel:
          this.menuBarConfig = form;
          this.menuPanelIndex = index;
          break;
        case this.formTypes.section:
          this.widgetsForm = form;
          this.widgetsFormIndex = index;
          break;
        default:
          break;
      }
    })
  }

  updateStyles(primary: any, secondary: any, background: any, themeType: string) {
    const styleTag: HTMLStyleElement = this.renderer.createElement("style");
    const styleContent: string = themeType.toLocaleLowerCase().includes("dark")
      ? `:root,:host {--md-sys-color-primary:${primary};
    --md-sys-color-on-primary:${secondary};--md-sys-color-primary-container:rgb(0 0 230);--md-sys-color-on-primary-container:rgb(164 170 255);--md-sys-color-primary-fixed:rgb(224 224 255);--md-sys-color-on-primary-fixed:rgb(0 0 110);--md-sys-color-primary-fixed-dim:rgb(190 194 255);--md-sys-color-on-primary-fixed-variant:rgb(0 0 239);--md-sys-color-secondary:rgb(190 194 255);--md-sys-color-on-secondary:rgb(25 31 137);--md-sys-color-secondary-container:rgb(44 50 152);--md-sys-color-on-secondary-container:rgb(157 164 255);--md-sys-color-secondary-fixed:rgb(224 224 255);--md-sys-color-on-secondary-fixed:rgb(0 0 110);--md-sys-color-secondary-fixed-dim:rgb(190 194 255);--md-sys-color-on-secondary-fixed-variant:rgb(51 58 159);--md-sys-color-tertiary:rgb(255 180 169);--md-sys-color-on-tertiary:rgb(105 0 1);--md-sys-color-tertiary-container:rgb(140 0 2);--md-sys-color-on-tertiary-container:rgb(255 145 129);--md-sys-color-tertiary-fixed:rgb(255 218 213);--md-sys-color-on-tertiary-fixed:rgb(65 0 0);--md-sys-color-tertiary-fixed-dim:rgb(255 180 169);--md-sys-color-on-tertiary-fixed-variant:rgb(147 0 2);--md-sys-color-error:rgb(255 180 171);--md-sys-color-on-error:rgb(105 0 5);--md-sys-color-error-container:rgb(147 0 10);--md-sys-color-on-error-container:rgb(255 218 214);--md-sys-color-outline:rgb(115 115 135);--md-sys-color-background:rgb(18 18 29);--md-sys-color-on-background:rgb(227 225 241);--md-sys-color-surface:rgb(18 18 29);--md-sys-color-on-surface:rgb(227 225 241);--md-sys-color-surface-variant:rgb(69 69 88);--md-sys-color-on-surface-variant:rgb(197 196 219);--md-sys-color-inverse-surface:rgb(227 225 241);--md-sys-color-inverse-on-surface:rgb(47 47 59);--md-sys-color-inverse-primary:rgb(52 61 255);--md-sys-color-shadow:rgb(0 0 0);--md-sys-color-surface-tint:rgb(190 194 255);--md-sys-color-outline-variant:rgb(69 69 88);--md-sys-color-scrim:rgb(0 0 0);--md-sys-color-surface-container-highest:rgb(51 52 64);--md-sys-color-surface-container-high:rgb(41 41 53);--md-sys-color-surface-container:rgb(30 31 42);--md-sys-color-surface-container-low:rgb(26 27 38);--md-sys-color-surface-container-lowest:rgb(13 13 24);--md-sys-color-surface-bright:rgb(56 56 68);--md-sys-color-surface-dim:rgb(18 18 29);}`
      : `
      :root,
      :host {
      --md-sys-color-primary:${primary};
      --md-sys-color-on-primary:${secondary};
      --md-sys-color-primary-container:rgb(224 224 255);
      --md-sys-color-on-primary-container:rgb(14 18 83);
      --md-sys-color-primary-fixed:rgb(224 224 255);
      --md-sys-color-on-primary-fixed:rgb(14 18 83);
      --md-sys-color-primary-fixed-dim:rgb(190 194 255);
      --md-sys-color-on-primary-fixed-variant:rgb(60 65 128);--md-sys-color-secondary:rgb(92 93 114);--md-sys-color-on-secondary:rgb(255 255 255);--md-sys-color-secondary-container:rgb(225 224 249);--md-sys-color-on-secondary-container:rgb(25 26 44);--md-sys-color-secondary-fixed:rgb(225 224 249);--md-sys-color-on-secondary-fixed:rgb(25 26 44);--md-sys-color-secondary-fixed-dim:rgb(197 196 221);--md-sys-color-on-secondary-fixed-variant:rgb(68 69 89);--md-sys-color-tertiary:rgb(120 83 107);--md-sys-color-on-tertiary:rgb(255 255 255);--md-sys-color-tertiary-container:rgb(255 216 238);--md-sys-color-on-tertiary-container:rgb(46 17 38);--md-sys-color-tertiary-fixed:rgb(255 216 238);--md-sys-color-on-tertiary-fixed:rgb(46 17 38);--md-sys-color-tertiary-fixed-dim:rgb(232 185 213);--md-sys-color-on-tertiary-fixed-variant:rgb(94 60 82);--md-sys-color-error:rgb(186 26 26);--md-sys-color-on-error:rgb(255 255 255);--md-sys-color-error-container:rgb(255 218 214);--md-sys-color-on-error-container:rgb(65 0 2);--md-sys-color-outline:rgb(116 115 125);--md-sys-color-background:rgb(251 248 255);--md-sys-color-on-background:rgb(27 27 33);--md-sys-color-surface:rgb(251 248 255);--md-sys-color-on-surface:rgb(27 27 33);--md-sys-color-surface-variant:rgb(228 225 236);--md-sys-color-on-surface-variant:rgb(70 70 79);--md-sys-color-inverse-surface:rgb(48 48 54);--md-sys-color-inverse-on-surface:rgb(242 239 247);--md-sys-color-inverse-primary:rgb(190 194 255);--md-sys-color-shadow:rgb(0 0 0);--md-sys-color-surface-tint:rgb(84 89 153);--md-sys-color-outline-variant:rgb(199 197 208);--md-sys-color-scrim:rgb(0 0 0);
  
      --md-sys-color-surface-container-high:rgb(234 231 239);--md-sys-color-surface-container:rgb(240 236 244);--md-sys-color-surface-container-low:rgb(245 242 250);--md-sys-color-surface-container-lowest:rgb(255 255 255);--md-sys-color-surface-bright:rgb(251 248 255);--md-sys-color-surface-dim:rgb(219 217 224);
      }
    `;
    // --md-sys-color-surface-container-highest:${secondary};

    this.renderer.appendChild(styleTag, this.renderer.createText(styleContent));

    // Remove any existing style tags
    const existingStyles: NodeListOf<HTMLStyleElement> =
      this.el.nativeElement.querySelectorAll("style");
    existingStyles.forEach((style) =>
      this.renderer.removeChild(this.el.nativeElement, style)
    );

    // Append the new style tag to the component's element
    this.renderer.appendChild(this.el.nativeElement, styleTag);
  }


  applyPageTheme(page:any){
    if(page && page.pageConfig && this.applicationTheme){
        page.pageConfig.style = {
          backgroundColor:this.applicationTheme.defaultBackgroundColor,
        }
      page.forms.forEach((form : any) => {
        if(form.formConfig?.style && form.formConfig?.customStyleApplied == false){
          if (form.formConfig.formType === "Navgation Bar") {
              form.formConfig.style = {
                backgroundColor:this.applicationTheme.primaryColor
              }
            }
          else if(form.formConfig.formType === "menuPanel"){
            form.formConfig.style = {
              backgroundColor:this.applicationTheme.defaultBackgroundColor
            }
          }else{
            form.formConfig.style = {
            }
          }
        }

        form.widgets.forEach((widget: any) => {
          this.applyFormWidgetStyles(widget,this.applicationTheme);
        })
      })
    }
  }

  applyFormWidgetStyles(widget : any,theme:THEME){
    let excludedTypes = [this.widgetTypes.navButton, this.widgetTypes.separator,this.widgetTypes.fingerPrint,this.widgetTypes.faceId];
    
    if(!widget.widgetConfig.style['font-style'] && !excludedTypes.includes(widget?.widgetType)){
      (widget.widgetConfig.style as any)['font-size'] = "16px";
    }
    if(!widget.widgetConfig.style['margin-top'] && widget.widgetType !== this.widgetTypes.navText && widget.widgetType !== this.widgetTypes.navButton){
      (widget.widgetConfig.style as any)['margin-top'] = "16px";
    }
    if (widget?.widgetConfig?.customStyleApplied) {
      return; 
    }

    switch (widget?.widgetType) {
      case this.widgetTypes.textbox:
        if(widget && widget.widgetConfig.style){
        (widget.widgetConfig.style as any)['color'] = theme?.defaultTextColor;
        }
        break;
      case this.widgetTypes.button:
      case this.widgetTypes.printer:
        if(widget.widgetConfig && widget.widgetConfig.style)
        {
        (widget.widgetConfig.style as any)['backgroundColor'] = theme?.primaryColor;
        (widget.widgetConfig.style as any)['color'] = theme?.secondaryColor;
        }
        break;
      case this.widgetTypes.plainText:
      case this.widgetTypes.filePicker:
      case this.widgetTypes.image:
      case this.widgetTypes.searchableDropdown:
      case this.widgetTypes.dropdown:
      case this.widgetTypes.singleselectcheckbox:
      case this.widgetTypes.radio:
      case this.widgetTypes.date:
      case this.widgetTypes.scanner:
      case this.widgetTypes.address:
      case this.widgetTypes.geotag:
      case this.widgetTypes.geofence:
        if(widget.widgetConfig && widget.widgetConfig.style)
        (widget.widgetConfig.style as any)['color'] = theme.defaultTextColor;
        break;
      case this.widgetTypes.separator:
        if(widget.widgetConfig && widget.widgetConfig.style)
        (widget.widgetConfig.style as any)['color'] = theme.primaryColor;
        break;
        case this.widgetTypes.navText:
          if(widget.widgetConfig && widget.widgetConfig.style)
          (widget.widgetConfig.style as any)['color'] = theme.secondaryColor;
          break;
          case this.widgetTypes.navButton:
            if(widget.widgetConfig && widget.widgetConfig.style)
            (widget.widgetConfig.style as any)['color'] = theme.secondaryColor;
            break;
      default:
        break;
    }
  }

  

  applyWidgetStyles(widget: WIDGET, newTheme: THEME): void {
    if (widget.customStyleApplied) {
      return; // Skip if styles are already applied
    }

    switch (widget.widgetType) {
      case this.widgetTypes.textbox:
        if(widget && widget.style)
        (widget.style as any)['color'] = newTheme.defaultTextColor;
        break;
      case this.widgetTypes.button:
        if(widget && widget.style)
        {
        (widget.style as any)['backgroundColor'] = newTheme.primaryColor;
        (widget.style as any)['color'] = newTheme.defaultTextColor;
        }
        break;
        case this.widgetTypes.plainText:
        case this.widgetTypes.filePicker:
        case this.widgetTypes.image:
        case this.widgetTypes.searchableDropdown:
        case this.widgetTypes.dropdown:
        case this.widgetTypes.singleselectcheckbox:
        case this.widgetTypes.radio:
        case this.widgetTypes.date:
        if(widget && widget.style)
        (widget.style as any)['color'] = newTheme.defaultTextColor;
        break;
      default:
        break;
    }
  }

  onDrop(event: any,newlyAddedIndex:any) {
    if(this.pageData.pageType === Default_Pages.SplashScreenPage || this.pageData.pageType === Default_Pages.LoginPage) return;
    this.sharedSrv.setDisplayRestrictedArea(false);
    let data = event;
    this.dropData=data;
    const timeStamp = '-CD-' + Date.now();
    if('pageType' in data){
      this.openModal(this.addPagePopUpTemplate,'add')
    }else if ('widgets' in data) {
      this.spinnerActive = true;
      if (data.sectionType === "Navgation Bar") {
        if (data?.style) {
          data.key = this.pageData.pageName.slice(0,2)+this.pageIndex.toString()+'-NavBar'+this.pageSectionList1.length.toString()+timeStamp;
          data.style.backgroundColor = this.applicationTheme.primaryColor;
        }
      }
      else if (data.sectionType === "menuPanel") {
        if (data?.style) {
          data.key = this.pageData.pageName.slice(0,2)+this.pageIndex.toString()+'-manuPanel'+this.pageSectionList1.length.toString()+timeStamp;
          data.style.backgroundColor = this.applicationTheme.primaryColor;
        }
      }
      else {
        this.spinnerActive = true;
        if (data?.style) {
          data.key = this.pageData.pageName.slice(0,2)+this.pageIndex.toString()+"Customform"+this.pageSectionList1.length.toString()+timeStamp;
          data.style.backgroundColor = this.applicationTheme.secondaryColor;
        }
      }
      let count = 1;
      data.widgets.forEach((widget:WIDGET) => {
        widget.key = this.pageData.pageName.slice(0,1)+this.pageIndex.toString()+"-form"+this.pageSectionList1.length.toString()+"-"+widget.name.slice(0,2)+count+timeStamp;
        count++;
      })
      if(this.pageData.pageId) {
        if (this.pageData.forms.some((form: any) => form.formConfig.formType === 'Navgation Bar')) {
          this.toastrSer.warning("Navbar already exists")
          this.spinnerActive = false; 
          return
        }
        let refreshPagesData: boolean = false;
        if(data.widgets?.find((widget: any) => widget.widgetType === this.widgetTypes.chatView)) {
          refreshPagesData = true;
        }
        this.sharedSrv.addSection(this.pageData.pageId,data,this.pageData).pipe(switchMap(() => this.refreshPageById(this.pageData.pageId as string, refreshPagesData)),catchError((error:any) =>{
          console.error('Error updating form list:', error);
          return of(null);
        })).pipe(takeUntil(this.destroy$)).subscribe((response : any) => {
          this.spinnerActive = false;
          if(data.widgets?.find((widget: any) => widget.widgetType === this.widgetTypes.chatView)) {
            this.sharedSrv.getAllPagesRefreshActionTrigger();
          }
        },
        (error) => {
          this.toastrSer.error("Error while addding widget")
          this.spinnerActive = false;
        });
        }
    } 
    else if(!this.widgetDropTriggered)
    { 
      this.spinnerActive = true;
      let formIndex = this.pageData.forms.findIndex((form: any) => form.formConfig.formType === 'section');
      if(formIndex === -1){
      data.key = this.pageData.pageName.slice(0,2)+"-"+this.pageIndex.toString()+"-from"+this.pageSectionList1.length.toString()+"-"+data.name.slice(0,2)+'1'+timeStamp;
      let section:SECTION = {sectionId:this.pageSectionList1.length.toString(), key:this.pageData.pageName.slice(0,2)+this.pageIndex.toString()+"form-"+this.pageSectionList1.length.toString(),name:"section"+this.pageSectionList1.length.toString(),widgets:[data,],isEditable:true,showDeleteButton:false,image:"box",style:{},sectionType:'section'} ;
      (section.style as any)['backgroundColor'] = this.applicationTheme.secondaryColor;
      if(this.pageData.pageId) {
        let refreshPagesData: boolean = false;
        if(section.widgets?.find((widget: any) => widget.widgetType === this.widgetTypes.chatView)) {
          refreshPagesData = true;
        }
        this.sharedSrv.addSection(this.pageData.pageId,section,this.pageData).pipe(switchMap(() => this.refreshPageById(this.pageData.pageId as string, refreshPagesData)),catchError((error:any) =>{
          console.error('Error updating form list:', error);
          return of(null);
      })).pipe(takeUntil(this.destroy$)).subscribe((data : any) => {
        this.spinnerActive = false;
        if(section.widgets?.find((widget: any) => widget.widgetType === this.widgetTypes.chatView)) {
          this.sharedSrv.getAllPagesRefreshActionTrigger();
        }
      },
      (error) => {
        this.toastrSer.error("Error while addding widget")
        this.spinnerActive = false;
      });
      }
    this.widgetDropTriggered = false;
    }
    else{
        if (this.pageSectionList1[formIndex] && this.pageSectionList1[formIndex].formConfig?.formType !== 'Navgation Bar') {
          data.key = this.pageData.pageName.slice(0,2)+this.pageIndex.toString()+"-"+"from"+formIndex+"-"+data.name.slice(0,2)+this.pageSectionList1[formIndex].widgets?.length+timeStamp;
  
          if(this.pageData.pageId)
          this.sharedSrv.updatePageSectionList(this.pageSectionList1,this.pageData.pageId);
          this.sharedSrv.updateFormList(this.pageData.pageId as string, data, this.pageData, formIndex,this.pageSectionList1[formIndex],newlyAddedIndex).pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.getPageById(this.pageId).pipe(takeUntil(this.destroy$)).subscribe((data) => {
              this.pageData = data;
              this.pageSectionList1 = data.forms;
              this.applyPageTheme(this.pageData);
              this.sharedSrv.setSelectedPage(data);
              this.spinnerActive = false;
              if(data.widgetType === this.widgetTypes.chatView) {
                this.sharedSrv.getAllPagesRefreshActionTrigger();
              }
            },
            (error) => {
              this.toastrSer.error("Error while addding widget")
              this.spinnerActive = false;
            })
          },
          (error) => {
            this.toastrSer.error("Error while addding widget")
            this.spinnerActive = false;
          })
        }
      
    }
  }
}
  
  private refreshPageById(pageId: string, refreshPagesData: boolean) {
    return this.getPageById(pageId).pipe(
      switchMap((data) => {
        this.pageData = data;
        this.pageSectionList1 = data.forms;
        this.applyPageTheme(this.pageData);
        this.sharedSrv.setSelectedPage(data);
        this.spinnerActive = false;
        if(refreshPagesData) {
          this.sharedSrv.getAllPagesRefreshActionTrigger();
        }
        return [];
      }),
      catchError(error => {
        if(error?.status == 403) {
          this.toastrSer.error('You do not have permission to access this resource.');
        }
        console.error('Error refreshing page:', error);
        return of(null);
      })
    );
  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }

  sectionRearrange(event: CdkDragDrop<any[]>): void {
    moveItemInArray(this.pageSectionList1, event.previousIndex, event.currentIndex);

    this.sharedSrv.updatePageSectionList(this.pageSectionList1,this.pageId);
    let pageForms:any[] = [];
    this.pageSectionList1.forEach((form) => {
      pageForms.push(form.formId);
    })
    let pagePostData = {
      pageId : this.pageId,
      pageForms :  pageForms,
      style:this.pageData.pageConfig?.style,
      applicationId:this.applicationId
    }
    this.sharedSrv.updatePageData(pagePostData as any).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.getPageById(this.pageId).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.sharedSrv.setSelectedPage(data);
      })
    })
  }

  restrict(section: SECTION) {
    this.isEditableSection = section.isEditable;
  }

  widgetRearrange(event: CdkDragDrop<any[]>, index: number): void {
    this.spinnerActive = true;
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
    else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
    this.sharedSrv.updateformWidgets(this.pageSectionList1,this.pageId,index);
    this.sharedSrv.updatePageSectionList(this.pageSectionList1,this.pageId);
    this.spinnerActive = false;
  }



  onClick(widgetId: string, sectionIndex: number, widgetIndex: number, widgetMeta: WIDGET) {
    this.sharedSrv.setPageData(this.pageData.pageName);
    this.sharedSrv.setSelectedOption("Pages",true);
    this.sharedSrv.setSelectedOptionAsLastedSelected("Pages");
    if(this.pageId){
    this.sharedSrv.setPagesExpansionPanelOpener({pageID:this.pageId,sectionIndex:sectionIndex,widgetIndex:widgetIndex});
    this.sharedSrv.onMobileScreenDropUpdateData({ 'data': widgetId, 'onClick': true, 'sectionIndex': sectionIndex, 'widgetIndex': widgetIndex, 'widgetMeta': widgetMeta });
    this.sharedSrv.setSidenavContentlistOption('widget',true);
    }
  }


  onSectionClick(sectionIndex:number,section:FORMI){
    this.sharedSrv.setSelectedOption("Pages",true);
    this.sharedSrv.setPagesExpansionPanelOpener({pageID:this.pageId,sectionIndex:sectionIndex});
  }

  deleteSection(index: number, section: any, page:PAGEI ,widget?:any ): void {
    if(section.formConfig?.formType === 'Navgation Bar'){
      section.formConfig.enable = false;
      this.sharedSrv.setSidenavContentlistOption('widget', false);
      return;
    }
    if (section?.open) {
      this.sharedSrv.setSidenavContentlistOption('widget', false);
    }
    this.spinnerActive = true;
    /** Added for deleting menupanel form is it exits */
    this.pageSectionList1.map((section: any) => {
      if (section?.formConfig?.formType == 'menuPanel') {
        this.sharedSrv.deleteForm(section.formId, page).pipe(takeUntil(this.destroy$)).subscribe((value) => { })
      }
    })
    this.sharedSrv.deleteForm(section.formId, page).pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if(widget.widgetConfig?.previewPageId || widget.widgetConfig?.dataListViewPageId){
        this.sharedSrv.getAllPagesRefreshActionTrigger();
      }
      this.getPageById(this.pageId).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.pageData = data;
        this.pageSectionList1 = data.forms;
        this.applyPageTheme(this.pageData);
        this.sharedSrv.setSelectedPage(data);
        this.spinnerActive = false;
      }, (error) => {
        if(error?.status == 403) {
          this.toastrSer.error('You do not have permission to access this resource.');
        }
        console.error('Error deleting form section', error);
        this.spinnerActive = false;
      })
    },
      (error) => {
        console.error('Error deleting form section', error);
        this.spinnerActive = false;
      });
  }


  deleteWidget(currentPageData: PAGEI, formIndex: number,form:any, widget: any) {
    if(widget.open){
      this.sharedSrv.setSidenavContentlistOption('widget',false);
    }
    if(form.widgets.length > 1){
    this.spinnerActive = true;
    this.sharedSrv.deleteWidget(currentPageData, formIndex, widget.widgetId ,widget.widgetConfig?.previewPageId ?? widget.widgetConfig?.dataListViewPageId);
      this.pageSectionList1[formIndex].widgets = (this.pageSectionList1?.[formIndex]?.widgets || []).filter((widgetdata: any) => widgetdata.widgetId !== widget.widgetId);
    this.spinnerActive = false;
    }else{
      this.deleteSection(formIndex,form,currentPageData,widget);
    }
  }

  setHoveredWidget(sectionIndex: number, widgetIndex: number) {
    this.currentlyHoveredWidget = { sectionIndex, widgetIndex };
  }

  clearHoveredWidget() {
    this.currentlyHoveredWidget = null;
  }

  updateTime() {
    const time = new Date();
    this.currentTime = time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
  }
  loadFont(): void {
    const selectedHeadFont = this.selectedHeadFontFamily.replace(/ /g, '+');
    const selectedBodyFont = this.selectedBodyFamily.replace(/ /g, '+');
    WebFont.load({
      google: {
        families: [`${selectedHeadFont}:wght@400`,`${selectedBodyFont}:wght@400`],
      },
    });
  }
  buildForms(){
    this.addPageForm = this._formBuilder.group({
      name:['', Validators.required],
      description:['']
      })
  }
  openModal(template:TemplateRef<any>,type:any): void {
    const dialogRef = this.dialog.open(template, {
      disableClose: true
    });
    if(type=='add'){
      this.editPage = false;
      this.pageAlreadyExits = false;
    }
  }
  savePage(){
    this.spinnerActive = true;
    const currentParams = { ...this.route.snapshot.queryParams };
    if(!this.editPage){
      this.sharedSrv.addPageData(currentParams['id'],this.addPageForm.getRawValue()).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
        this.closeTemplate();
       if(this.dropData?.pageType!="CustomPage"){
        this.addMasterPages(this.dropData,data?.pageId)
       }
       this.sharedSrv.setSidenavContentlistOption('',false);
       this.router.navigate(["home","mobile"], {
        queryParams: {
          "id":this.queryParamsData?.id,
          "applicationType":this.queryParamsData?.applicationType,
          "pageId":data?.pageId
        }
      });
      this.spinnerActive = false;
    },(error:any) => {
        if(error?.error?.result?.includes("already exists")){
          this.pageAlreadyExits = true;
        }
      })
    }
  }
  closeTemplate(): void {
    this.addPageForm.reset();
    this.dialog.closeAll();
  }
  addMasterPages(page:any,pageId:any){
    if (page && page?.pageConfig) {
        for (let formIndex = 0; formIndex < page.pageConfig?.forms?.length; formIndex++) {
          page.pageConfig.forms[formIndex].formKey = page?.pageConfig?.pageName?.slice(0,2)+"0"+"Customform"+formIndex.toString();
          for(let widgetsIndex=0; widgetsIndex <  page.pageConfig?.forms[formIndex]?.widgets.length; widgetsIndex++){
            page.pageConfig.forms[formIndex].widgets[widgetsIndex].widgetKey = page?.pageConfig?.pageName?.slice(0,1)+"0"+"-form"+formIndex.toString()+"-"+page.pageConfig?.forms[formIndex]?.widgets[widgetsIndex]?.widgetLabel.slice(0,2)+widgetsIndex.toString();
            if(widgetsIndex >= page?.pageConfig?.forms[formIndex]?.widgets.length-1){
              let payload ={
                applicationId:this.applicationId,
                previousLoginPageId : pageId,
                loginPage: page
              }
              this.sharedSrv.createDropedPage(payload).pipe(takeUntil(this.destroy$)).subscribe((pages: any) => {
                this.getPageById(pages?.pageId).pipe(takeUntil(this.destroy$)).subscribe((data) => {
                  this.pageData = data;
                  this.pageSectionList1 = data?.forms;
                  this.applyPageTheme(this.pageData);
                  this.sharedSrv.setSelectedPage(data);
                })
              });
            }
          }
        }
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());

    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
  navigateToPages() {
    localStorage.setItem(LAST_SELECTED_OPTION, 'Pages');
  }
}
